import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor } from '../../Theming';
import { Maybe } from '../TreeplantingContext';

const Container = styled.section`
  background-color: ${themeColor('greyBackground')};
  padding: 50px 45px 50px 45px;
  margin-top: 40px;
  text-align: center;
  border-radius: 20px;
  height: 387px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mobileMediaQuery} {
    margin-top: 12px;
    padding: 12px 45px 12px 45px;
    border-radius: 6.11px;
    height: 130px;
  }
`;

const Text = styled.p`
  font-family: SuisseIntl-Medium;
  margin: 0;
  padding: 0;
  font-size: 32px;
  font-weight: bold;
  font-weight: normal;

  ${mobileMediaQuery} {
    font-family: SuisseIntl-Regular;
    font-size: 12px;
  }
`;

const BoldText = styled(Text)`
  font-family: SuisseIntl-Bold;
  font-size: 72px;
  line-height: 82px;

  ${mobileMediaQuery} {
    font-size: 28px;
    line-height: 30px;
  }
`;

interface Props {
  numOfTreesToday?: Maybe<number>;
  totalNumOfTrees?: Maybe<number>;
}

const TreesFunded: React.FC<Props> = ({ totalNumOfTrees = '1,043' }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Text>{t('treePlantingV2.treeFunding.treesFunded')}</Text>
      <BoldText>{`${totalNumOfTrees} ${t(
        'treePlantingV2.treeFunding.trees'
      )}`}</BoldText>
      <Text>{t('treePlantingV2.treeFunding.acrossTheUAE')}</Text>
    </Container>
  );
};

export default TreesFunded;
